import { GetSegmentedCheckoutMetricsInsightsOutput_ } from "@redotech/redo-model/conversion/checkout-segments/segmented-checkout-metrics-insights";
import * as z from "zod";

export const getSegmentedCheckoutMetricsInsights = {
  name: "getSegmentedCheckoutMetricsInsights" as const,
  input: z.null(),
  output: GetSegmentedCheckoutMetricsInsightsOutput_,
};
